/**
 * Трёхбуквенные сокращения кластеров Ozon для чипов в узких ячейках
 * («Мск 12/40 · Кзн 5/0»). Полные названия остаются в подсказках; для
 * карты и бейджей есть более длинный вариант — clusterShortName в
 * app/supply-pult/russia-map-data.
 */

const CLUSTER_ABBREVIATIONS: Record<string, string> = {
  "Москва, МО и Дальние регионы": "Мск",
  "Москва": "Мск",
  "Санкт-Петербург и СЗО": "СПб",
  "Санкт-Петербург": "СПб",
  "Казань": "Кзн",
  "Новосибирск": "Нск",
  "Екатеринбург": "Екб",
  "Краснодар": "Крд",
  "Ростов": "Ртв",
  "Ростов-на-Дону": "Ртв",
  "Самара": "Смр",
  "Воронеж": "Врж",
  "Тверь": "Твр",
  "Уфа": "Уфа",
  "Красноярск": "Крс",
  "Омск": "Омск",
  "Пермь": "Прм",
  "Тюмень": "Тмн",
  "Калининград": "Клг",
  "Ярославль": "Ярс",
  "Саратов": "Срт",
  "Оренбург": "Орб",
  "Махачкала": "Мхч",
  "Невинномысск": "Нвм",
  "Дальний Восток": "ДВ",
  "Хабаровск": "Хбр",
  "Владивосток": "Влд",
  "Нижний Новгород": "ННв",
  "Волгоград": "Влг",
  "Челябинск": "Чел",
  "Иркутск": "Ирк",
  "Ижевск": "Ижв",
  "Алматы": "Алм",
  "Астана": "Аст",
  "Беларусь": "Блр",
  "Минск": "Мнс",
  "Армения": "Арм",
  "Ташкент": "Тшк",
  "Без кластера": "—",
};

/** «Казань» → «Кзн»; незнакомый кластер — первые три буквы первого слова. */
export function clusterAbbreviation(cluster: string): string {
  const known = CLUSTER_ABBREVIATIONS[cluster];
  if (known) return known;
  const word = cluster.trim().split(/[\s,]+/)[0] ?? "";
  return word.length <= 4 ? word : word.slice(0, 3);
}
